import { packageInfo } from '@/config/package-info' // Importa as informações do package.json

const VersionInfo = () => {
  return (
    <div className="flex justify-center pt-1">
      <div className="flex flex-col text-foreground text-xs leading-tight tracking-tight rounded-md items-center">
        <p className="whitespace-nowrap">Tribmaster {packageInfo.version}</p>
        <p className="whitespace-nowrap">© 2025 {packageInfo.author}</p>
      </div>
    </div>
  )
}

export default VersionInfo
